"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const api_1 = require("@/api");
const staticBankList = [
    'Paypal',
    '산업은행',
    '기업은행',
    '국민은행',
    '수협은행',
    '수출입은행',
    '농협은행',
    '지역농축협',
    '우리은행',
    'SC제일은행',
    '한국씨티은행',
    '대구은행',
    '부산은행',
    '광주은행',
    '제주은행',
    '전북은행',
    '경남은행',
    '새마을금고중앙회',
    '신협',
    '중국공상은행',
    '중국은행',
    '교통은행',
    '중국건설은행',
    'KEB하나은행',
    '신한은행',
    '케이뱅크',
    '카카오뱅크',
    '신한저축은행',
    '우체국',
    '토스',
];
function default_1() {
    const [bankList, setBankList] = (0, react_1.useState)([]);
    const hasBankList = Boolean(bankList);
    (0, react_1.useEffect)(() => {
        (0, api_1.getData)(`/api/v1/credit/bank-list`)
            .then(res => {
            if (res.status === 200) {
                setBankList(res.data.result);
            }
        })
            .catch(() => {
            setBankList(staticBankList);
        });
    }, []);
    return { hasBankList, bankList };
}
exports.default = default_1;
